import * as React from 'react';
import classnames from 'classnames';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import './checkbox-selector.scss';

import type { DataStructureCommon } from 'types';

type Props = {
  items: Array<DataStructureCommon>,
  attribute: string,
  direction?: 'row' | 'column',
  customClass?: string,
  containerClass?: string,
  onUpdate?: (a: Array<DataStructureCommon>) => void
};

class CheckboxSelector extends React.PureComponent<Props> {
  static defaultProps = {
    direction: 'row',
    containerClass: 'checkbox-selector__checkbox'
  };

  handleChange(changedItem: DataStructureCommon, selected: boolean): void {
    const { items, onUpdate } = this.props;

    const updatedItems = items.map((item) => {
      if (item.value === changedItem.value) {
        return {
          ...item,
          selected
        };
      }

      return item;
    });

    if (onUpdate) {
      onUpdate(updatedItems);
    }
  }

  render() {
    const { attribute, items, direction, customClass, containerClass } = this.props;

    const classes = classnames({
      'checkbox-selector__inputs': true,
      [`checkbox-selector__inputs--direction-${String(direction)}`]: direction,
      [String(customClass)]: customClass
    });

    return (
      <div className={classes}>
        {
          items.map((item, index) => (
            <InputCheckbox
              id={`checkbox-selector__${attribute}-${index}`}
              key={index}
              name="item"
              value={item.value}
              label={item.label}
              type="filter"
              checked={item.selected}
              containerClass={containerClass}
              onChange={(event) => {
                this.handleChange(item, event.target.checked);
              }}
            />
          ))
        }
      </div>
    );
  }
}

export default CheckboxSelector;
